import styled, { th } from '@xstyled/styled-components'
import { Durations } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'

export function MoteCardRichFloatingDuration({ type = 'total', duration }) {
  const { playerDimensions } = useMotePlayer()

  return (
    <Root
      padding={moteCardFluidDimensionsAdjuster(8, 4, playerDimensions?.width)}
    >
      <Durations
        totalTime={duration}
        color='white'
        fontSize={moteCardFluidDimensionsAdjuster(
          18,
          12,
          playerDimensions?.width
        )}
        variant={type === 'total' ? 'compact-total' : 'compact-remaining'}
      />
    </Root>
  )
}

const Root = styled.div`
  background: ${th.color('black')};
  border-radius: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: ${({ padding }) => padding}px;
  margin: 6%;
`
